// extracted by mini-css-extract-plugin
export default {"locked":"g5zUPPKjkvVZUj2Qbulw","nameCol":"EwTNfjfCrPvLhTSe89W1","priceCol":"NgOLwRcJjy0YLT9rumfY","placeHolderShimmer":"du85t1oSwrwKYqMmP0gi"};